import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'survey/preview/main';

export const useSurveyPreviewQuery = ({
	impersonationContext,
	enabled = true,
}: {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			return new Promise<string>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceRawResponse(
					Api.ImpersonationBroker.composeApiUrl({
						urlPath: 'survey/preview/main',
						impersonationContext,
					}),
					'GET',
					null,
					async response => {
						resolve(await response.text());
					},
					error => {
						reject(error);
					}
				);
			});
		},
		queryKey: [BASE_QUERY_KEY, impersonationContext],
	});
};

export const invalidateSurveyPreviewQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
